import { FormattedMessage, injectIntl } from 'react-intl';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import striptags from 'striptags';
import messages from './messages';
import './styles.css';
import Grid from '../../components/Grid';
import Label from '../../components/Label';
import Icon from '../../components/Icon';

let scholarshipName = '';

const localOnChange = (e, onChange) => {
  const value = striptags(e.target.value);
  scholarshipName = value;
  onChange({ target: { value } }, 'name');
};

const onBlur = (e, onChange, setBlurred) => {
  setBlurred(true);
  onChange({ target: { value: scholarshipName } }, 'name');
  scholarshipName = '';
};

const onFocus = (e, setBlurred) => {
  const value = striptags(e.target.value);
  scholarshipName = value;
  setBlurred(false);
};

const ScholarshipName = ({ intl, index, name, onChange, errors, forceShowErrors }) => {
  const [blurred, setBlurred] = useState(false);
  return (
    <React.Fragment>
      <Grid.Row>
        <Grid.Column width={3}>
          <b><FormattedMessage {...messages.meritScholarshipsScholarshipNameLabel} /></b>
          <span styleName="required">&#x002a;</span>
        </Grid.Column>
        <Grid.Column width={12}>
          <input
            key={`scholarship-input-scholarship-name-${index}`}
            data-cy="scholarship-input-scholarship-name"
            aria-label="Name of scholarship"
            styleName="merit-scholarships-scholarship-name-input"
            value={name}
            placeholder={intl.formatMessage(messages.meritScholarshipsScholarshipNamePlaceholder)}
            onBlur={(e) => onBlur(e, onChange, setBlurred)}
            onFocus={(e) => onFocus(e, setBlurred)}
            onChange={(e) => localOnChange(e, onChange)}
            required
          />
          {(forceShowErrors || blurred) && (errors.duplicateName !== undefined || errors.requiredFieldsMissing.includes('name')) && (
            <div styleName="scholarship-name-errors-container">
              {errors.requiredFieldsMissing.includes('name') && (
                <Label role="tooltip" basic color="red" pointing data-cy="merit-scholarships-scholarships-name-required-error">
                  <Icon name="exclamation circle" styleName="validationError" size="large" />
                  <FormattedMessage {...messages.meritScholarshipsRequiredField} />
                </Label>
              )}
              {errors.duplicateName && (
                <Label role="tooltip" basic color="red" pointing data-cy="merit-scholarships-scholarships-duplicate-name">
                  <Icon name="exclamation circle" styleName="validationError" size="large" />
                  {errors.duplicateName}
                </Label>
              )}
            </div>
          )}
        </Grid.Column>
      </Grid.Row>
    </React.Fragment>
  );
};

ScholarshipName.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  index: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  errors: PropTypes.shape({
    requiredFieldsMissing: PropTypes.arrayOf(PropTypes.string),
    duplicateName: PropTypes.string,
  }),
  forceShowErrors: PropTypes.bool,
};

export default injectIntl(ScholarshipName);
